<template>
    <div class="vrm-search-modal-results--empty">
        <p class="vrm-search-modal-results--empty--hint-desktop">
            {{
                $t('nav.enhanced_search.hints_title.to_start', {
                    i18nFallback: 'To start searching press',
                })
            }}
            <span class="sg-vrm-icon_145_return_16px"></span>
            {{
                $t('nav.enhanced_search.hints_title.or_click', {
                    i18nFallback: 'or click the',
                })
            }}
            <span class="sg-vrm-icon_144_search_minimal_16px"></span>
            {{
                $t('nav.enhanced_search.hints_title.icon', {
                    i18nFallback: 'icon',
                })
            }}
        </p>
        <p class="vrm-search-modal-results--empty--hint-mobile">
            {{
                $t('nav.enhanced_search.hints_title.to_start', {
                    i18nFallback: 'To start searching press',
                })
            }}
            <span class="sg-vrm-icon_143_search_button_16px"></span>
            {{
                $t('nav.enhanced_search.hints_title.or_click', {
                    i18nFallback: 'or click the',
                })
            }}
            <span class="sg-vrm-icon_144_search_minimal_16px"></span>
            {{
                $t('nav.enhanced_search.hints_title.icon', {
                    i18nFallback: 'icon',
                })
            }}
        </p>
        <p class="vrm-search-modal-results-list-title">
            {{
                $t('nav.enhanced_search.hints_details.search_by', {
                    i18nFallback: 'You can search by',
                })
            }}
        </p>
        <ul>
            <li v-for="option in searchByOptions" :key="option.i18n">
                {{
                    $t(option.i18n, {
                        i18nFallback: option.i18nFallback,
                    })
                }}
            </li>
        </ul>
    </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';
import { searchByOptions } from '@/vue/constants/search-enhanced';
import { AngularDirective } from '@/vue/decorators/angular-interop';
import { AngularLocaleBundle } from '@/angular-bridge/modules/i18n';

@Component
@AngularLocaleBundle('nav')
@AngularDirective('vrm-enhanced-search-active-empty')
export default class VrmEnhancedSearchActiveEmpty extends Vue {
    searchByOptions = searchByOptions; // used to display the search options in the search empty state
}
</script>
